import { render, staticRenderFns } from "./ShowRuler.vue?vue&type=template&id=10fd3598&scoped=true"
import script from "./ShowRuler.vue?vue&type=script&lang=js"
export * from "./ShowRuler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fd3598",
  null
  
)

export default component.exports